import { createContext, useContext, ReactNode } from 'react';
import { Loading } from '../components/Loading';
import { useConfig } from '@shared/data-access';

interface IServerConfigContext {
  mediaStorage: {
    url: string;
    maxImageSize: number;
  };
}

const ServerConfigContext = createContext<IServerConfigContext | undefined>(undefined);

export const ServerConfigContextProvider = ({ children }: { children: ReactNode }) => {
  const { data, isLoading: loading } = useConfig();

  if (loading) {
    return <Loading />;
  }

  const value = {
    mediaStorage: {
      url: data?.storagePrefix,
      maxImageSize: data?.maxImageSize,
    },
  } as IServerConfigContext;

  return <ServerConfigContext.Provider value={value}>{children}</ServerConfigContext.Provider>;
};

export const useServerConfig = () => {
  const ctx = useContext(ServerConfigContext);
  if (!ctx) throw new Error('useServerConfig must be used inside ServerConfigContext');
  return ctx;
};
